module.exports = __webpack_public_path__ + "static/media/joinTribesExample.c1563127.png";